// Shared non-component exports; keep component modules valid Fast Refresh boundaries.
import type { Role } from "./api";

export const ROLE_LABEL: Record<Role, string> = {
  supadmin: "SupaAdmin",
  admin: "Admin",
  manager: "Manager",
};
